import React from 'react';
import BasePage from '../BasePage';

const tags = ['er-', 'ein-', 'be-'];



export default function () {
    const props = {
        title: '"be", "ein", "er" Prefixes',
        tags
    };
    return (<BasePage { ...props } />);
}



/** WEBPACK FOOTER **
 ** ./app/components/pages/exercisePages/Prefixes/BeEinErPage.js
 **/